import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '@core';
import { AuthQuery } from '@app/auth/auth.query';
import { AuthDataService } from '@app/auth/auth-data.service';

const log = new Logger('ForgotPwd');

@Component({
  selector: 'app-forgot-pwd-page',
  templateUrl: './forgot-pwd-page.component.html',
  styleUrls: ['./forgot-pwd-page.component.scss'],
})
export class ForgotPwdPageComponent implements OnInit {
  version: string | null = environment.version;
  error: string | undefined;
  loginForm!: UntypedFormGroup;
  isLoading = false;
  showSuccessMessage = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private authQuery: AuthQuery,
    private authService: AuthDataService,
    private _snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    // Check for error messages from query params (e.g., from activation failures)
    this.route.queryParams.subscribe((params) => {
      const error = params['error'];
      const message = params['message'];
      
      if (error && message) {
        this._snackBar.open(message, 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 5000,
        });
      }
    });
  }

  // Register new page removed - not available
  // gotoRegisterNew() {
  //   this.router.navigateByUrl('/register-new');
  // }

  gotoLogin() {
    this.router.navigateByUrl('/login');
  }

  forgotPwd() {
    var username = this.authQuery.name;
    var userid = this.authQuery.userid;

    var email = this.loginForm.controls['email'].value;

    let data = {
      email: email,
      uid: userid,
    };

    this.isLoading = true;
    this.showSuccessMessage = false;
    this.error = undefined;

    const changePwd$ = this.authService.forgotpwd(data);
    changePwd$
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (data: any) => {
          console.log(data);

          // show success message div
          if (data.code == 200) {
            this.showSuccessMessage = true;
          } else {
            this.error = 'Fehler aufgetreten.';
            this._snackBar.open('Fehler aufgetreten.', 'Schließen', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 3000,
            });
          }
        },
        (error: any) => {
          // show error notification alert
          this.error = 'Fehler aufgetreten';
          this._snackBar.open('Fehler aufgetreten', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
      );
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
  }
}
